import { Image, Text, Flex } from "@chakra-ui/react";
import Lottie from "lottie-react";
import * as animationData from "./assets/data0.json";

const Slider1 = () => {
  return (
    <Flex
      sx={{
        height: "100%",
      }}
      align={"center"}
      flexDir={"column"}
    >
      <Text
        sx={{
          color: "#333",
          fontFamily: "DIN",
          fontSize: "14px",
          fontWeight: 500,
          position: "absolute",
          top: "20px",
          left: "0",
          zIndex: 10,
        }}
      >
        Welcome to Logs
      </Text>
      <Lottie
        animationData={animationData}
        loop={true}
        style={{
          width: "100%",
          marginTop: "30px",
          maxWidth: "400px",
        }}
      />

      <Text
        sx={{
          fontFamily: "DIN-Black",
          fontSize: "24px",
          fontStyle: "normal",
          fontWeight: 900,
          marginTop: "auto",
        }}
      >
        Accept Crypto Effortlessly Don’t Get Left Behind
      </Text>
    </Flex>
  );
};

export default Slider1;
